<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
            <span class="breadcrumb">IL MIO PROFILO</span>
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">
          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
            <img [src]="currentUser?.profileImg|s3Link"  (click)="showFoto()"/>
          </ion-avatar>
        </div>
        <app-add-bookmark slot="end"
                          pageTitle="Il mio profilo"
                          url="/my-profile"
        ></app-add-bookmark>
      </ion-toolbar>
      <br />

      <!-- edit da qui... -->


      <ion-avatar class="header-avatar">
        <img [src]="currentUser?.profileImg|s3Link" *ngIf="currentUser?.profileImg" (click)="openImageModal(currentUser?.profileImg)"/>

        <img class="space-below svg-white"  *ngIf="!currentUser?.profileImg" src="./assets/imgs/avatar.svg"
        />
        <span class="custom-icon-edit-icon" (click)="edit()"></span>
      </ion-avatar>
      <!-- ...a qui -->
    </ion-header>

    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content tillBottom">
            <!-- edit da qui... -->

            <div class="glass-blurred-background padding full-width text-bold">
              <h3 class="section-title">Personal Info</h3>

              <div class="flex-row info">
                <span class="label">Name:</span>
                <span class="detail">{{ currentUser?.name |titlecase }}</span>
              </div>
              <div class="flex-row info">
                <span class="label">Last name:</span>
                <span class="detail">{{ currentUser?.lastname  |titlecase}}</span>
              </div>
              <div class="flex-row info">
                <span class="label">Telefono:</span>
                <span class="detail">{{ currentUser?.phoneNumber }}</span>
              </div>
              <div class="flex-row info">
                <span class="label">Codice fiscale:</span>
                <span class="detail">{{ currentUser?.cf }}</span>
              </div>
              <div class="flex-row info">
                <span class="label">Numero documento :</span>
                <span class="detail">{{ currentUser?.numeroCI }}</span>
              </div>
              <div class="flex-row info">
                <span class="label">Email:</span>
                <span class="detail">{{ currentUser?.email }}</span>
              </div>
              <div class="flex-row info" *ngIf="currentUser?.addedBy">
                <span class="label">Added by:</span>
                <span class="detail">{{ addedByFullName }}</span>
              </div>


            </div>

            <!-- ...a qui -->
          </div>
          <!--  <h3 class="section-title">Upload files</h3>

           <app-upload-files [userId]="currentUser?.id"></app-upload-files>-->

        </div>
      </div>
    </ion-content>
  </div>
</div>

<!-- 



<ion-header>
    <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
            <div size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> 
          <span class="path2"></span> 
        </span>
                <span class="breadcrumb">IL MIO PROFILO</span>
            </div>
        </ion-buttons>
        <div class="notification-div">
            <div class="menu-user-icon">

            </div>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="profile-empty-div">
        <div class="employee-div" *ngIf="profile != 'summary'">
            <div>
                <div class="edit-icon">
                    <span class="custom-icon-edit-icon" (click)="edit()"></span>
                </div>
                <div class="user-icon">

                </div>
            </div>
        </div>

        <form class="filter-cnt" *ngIf="profile == 'summary'">
            <input name="name" class="search-input" placeholder="Ricerca" type="search">
        </form>
    </div>

    <div class="profile-content-div">

        <div>
            <div class="seg-content">
                <h4 class="seg-title">Personal Info</h4>
                <div class="border"></div>

                <ion-item detail="false" class="profile-item">
                    <ion-label>Name</ion-label>
                    <span slot="end">{{ currentUser?.name }}</span>
                </ion-item>
                <ion-item detail="false" class="profile-item">
                    <ion-label>Last name</ion-label>
                    <span slot="end">{{ currentUser?.lastname }}</span>
                </ion-item>
                <ion-item detail="false" class="profile-item">
                    <ion-label>Email</ion-label>
                    <span slot="end">{{ currentUser?.email }}</span>
                </ion-item>
                <ion-item detail="false" class="profile-item">
                    <ion-label>Phone</ion-label>
                    <span slot="end">{{ currentUser?.phoneNumber }}</span>
                </ion-item>

                <ion-item detail="false" class="profile-item" *ngIf="currentUser?.addedBy">
                    <ion-label>Added by</ion-label>
                    <span slot="end">{{ addedByFullName }}</span>
                </ion-item>

                <ion-item detail="false" class="profile-item">
                    <ion-label>Notes</ion-label>
                    <span slot="end">{{ currentUser?.notes }}</span>
                </ion-item>
            </div>

        </div>
    </div>

    <amplify-sign-out (click)="signout($event)"></amplify-sign-out>


</ion-content> -->
